import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Store
import { toggleLoaderState } from '@store/loader/loader.actions';
import { clearSingleServiceState } from '@store/single-service/single-service.actions';

// Services
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { WidgetsService } from '@services/widgets.service';

// Constants
import { LOCAL_STORAGE_KEYS, TLocalStorageKey } from '@constants/storage.constants';
export const USER_UNAUTHORIZED_CODE = 401;

export const JwtInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);
  const userService = inject(UserService);
  const router = inject(Router);
  const store = inject(Store);

  const widgetsService = inject(WidgetsService);
  const isWidget = widgetsService.getWidgetStatus();

  const user = userService.getUser();
  const isLoggedIn = Object.keys(user).length && user?.token;
  const token = isLoggedIn ? user?.token : localStorage.getItem(LOCAL_STORAGE_KEYS.TEMPORARY_TOKEN);
  if (
    request.url.includes('amazonaws') ||
    request.url.includes('api.openai.com') ||
    request.url.includes('aiden.dev-ee2e434d.helpmefix.io')
  ) {
    request = request.clone({
      setHeaders: {},
    });
  } else {
    request = request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
        'widget-code': isWidget ? widgetsService.getWidgetId().toString() : '',
      },
    });
  }

  if (request.url.includes('resend-activation-email')) {
    request = request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem(LOCAL_STORAGE_KEYS.TEMP_TOKEN),
      },
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error?.status === USER_UNAUTHORIZED_CODE && !request.url.includes('/api/log')) {
        authService.logoutUser().subscribe(() => {
          (Object.values(LOCAL_STORAGE_KEYS) as TLocalStorageKey[]).forEach(key => {
            if (key === LOCAL_STORAGE_KEYS.LINK_TYPE || key === LOCAL_STORAGE_KEYS.DEVICE_UDID)
              return;
            localStorage.removeItem(key);
          });

          if (!window.location.href.includes('deeplink')) {
            router.navigate(['/']);
          }

          store.dispatch(clearSingleServiceState());
          store.dispatch(toggleLoaderState({ state: false }));
          localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
          localStorage.removeItem(LOCAL_STORAGE_KEYS.DEEPLINK_TOKEN);
        });
      }

      return throwError(() => error);
    }),
  );
};
